const testimonials = [
  {
    name: 'Sarah Mitchell',
    role: 'Fashion Enthusiast',
    text: 'The Vigorbuy Spreadsheet completely changed how I shop online. Everything is organized and the QC guides saved me from several bad purchases. The updated vigorbuy spreadsheet is my go-to resource every week.',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20stylish%20young%20woman%20with%20warm%20smile%2C%20clean%20soft%20grey%20background%2C%20soft%20natural%20window%20lighting%2C%20minimalist%20editorial%20portrait%2C%20blush%20pink%20blouse%2C%20friendly%20genuine%20expression%2C%20modern%20corporate%20portrait%20style&width=120&height=120&seq=test-v3-t1&orientation=squarish',
  },
  {
    name: 'Marcus Thompson',
    role: 'Streetwear Collector',
    text: 'Finally, a spreadsheet that actually stays updated. I have found rare pieces I could not locate anywhere else. The category organization makes browsing effortless.',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20trendy%20young%20man%20with%20confident%20smile%2C%20clean%20soft%20grey%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20editorial%20style%2C%20olive%20green%20casual%20shirt%2C%20modern%20relaxed%20portrait%2C%20genuine%20expression&width=120&height=120&seq=test-v3-t2&orientation=squarish',
  },
  {
    name: 'Emily Rodriguez',
    role: 'Online Shopper',
    text: 'I was skeptical at first, but the best vigorbuy spreadsheet honestly delivered. The safety tips alone are worth bookmarking this page. Highly recommend for anyone shopping online.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20woman%20in%20warm%20rust%20orange%20outfit%20sitting%20by%20large%20window%20overlooking%20city%2C%20natural%20golden%20hour%20light%20streaming%20in%2C%20editorial%20lifestyle%20photography%2C%20warm%20amber%20and%20terracotta%20palette%2C%20relaxed%20genuine%20candid%20expression%2C%20modern%20minimalist%20interior%2C%20soft%20bokeh%20background&width=500&height=600&seq=test-v3-t3&orientation=portrait',
  },
  {
    name: 'David Park',
    role: 'Sneakerhead',
    text: 'The sneaker section alone is worth visiting. Organized by brand, style, and availability — it saves me hours every week. The updated vigorbuy spreadsheet is essential for any serious collector looking for the latest releases and restocks.',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20man%20with%20warm%20genuine%20smile%2C%20clean%20soft%20grey%20background%2C%20soft%20natural%20light%2C%20editorial%20portrait%2C%20minimalist%20style%2C%20navy%20casual%20sweater%2C%20friendly%20authentic%20expression&width=120&height=120&seq=test-v3-t4&orientation=squarish',
  },
];

export default function TestimonialSection() {
  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="w-12 h-12 flex items-center justify-center mx-auto rounded-2xl bg-accent-100 text-accent-600 mb-4">
            <i className="ri-double-quotes-l text-xl"></i>
          </span>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground-400 mb-3">
            Verified Community
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight">
            What Buyers Say
          </h2>
        </div>

        {/* Testimonial Grid - Irregular Layout */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Card 1 - Standard */}
          <div className="bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col">
            <span className="w-8 h-8 flex items-center justify-center text-accent-400 mb-4">
              <i className="ri-double-quotes-l text-2xl"></i>
            </span>
            <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-5">
              {testimonials[0].text}
            </p>
            <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
              <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                <img src={testimonials[0].avatarUrl} alt={testimonials[0].name} className="w-full h-full object-cover" />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-900">{testimonials[0].name}</p>
                <p className="text-xs text-foreground-500">{testimonials[0].role}</p>
              </div>
            </div>
          </div>

          {/* Card 2 - Standard */}
          <div className="bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col">
            <span className="w-8 h-8 flex items-center justify-center text-accent-400 mb-4">
              <i className="ri-double-quotes-l text-2xl"></i>
            </span>
            <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-5">
              {testimonials[1].text}
            </p>
            <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
              <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                <img src={testimonials[1].avatarUrl} alt={testimonials[1].name} className="w-full h-full object-cover" />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-900">{testimonials[1].name}</p>
                <p className="text-xs text-foreground-500">{testimonials[1].role}</p>
              </div>
            </div>
          </div>

          {/* Card 3 - Image Card */}
          <div className="relative rounded-2xl overflow-hidden min-h-[300px]">
            <img src={testimonials[2].imageUrl} alt={testimonials[2].name} className="w-full h-full object-cover" />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-5">
              <p className="text-white font-semibold text-sm">{testimonials[2].name}</p>
              <p className="text-white/70 text-xs">{testimonials[2].role}</p>
            </div>
          </div>

          {/* Card 4 - Wide (spans 2 cols) */}
          <div className="md:col-span-2 bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col md:flex-row gap-6 items-start">
            <div className="flex-1">
              <span className="w-8 h-8 flex items-center justify-center text-accent-400 mb-4">
                <i className="ri-double-quotes-l text-2xl"></i>
              </span>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                {testimonials[3].text}
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={testimonials[3].avatarUrl} alt={testimonials[3].name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{testimonials[3].name}</p>
                  <p className="text-xs text-foreground-500">{testimonials[3].role}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Card 5 - Small */}
          <div className="bg-background-50 rounded-2xl p-5 md:p-6 flex flex-col justify-center items-center text-center">
            <span className="text-4xl font-bold font-heading text-primary-500">50K+</span>
            <p className="text-sm text-foreground-500 mt-1">Happy Shoppers</p>
            <div className="flex mt-3">
              {[1, 2, 3, 4, 5].map((star) => (
                <span key={star} className="w-4 h-4 flex items-center justify-center text-primary-400">
                  <i className="ri-star-fill text-sm"></i>
                </span>
              ))}
            </div>
            <p className="text-xs text-foreground-400 mt-1">4.9 Average Rating</p>
          </div>
        </div>
      </div>
    </section>
  );
}